export default __webpack_public_path__ + "static/media/semmershoes.2293938a.svg";